import {Record} from 'immutable';
import moment, {type Moment} from 'moment-timezone';

import {parseDecimalToFloat} from 'web-app/util/parsers';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

export class Credit extends Record<{
    type: 'CREDIT';
    creditId: string;
    billPayerId: string;
    credited: number;
    createdAt: Moment;
    note: string;
    behaviors: BehaviorsCollection;
    accountId?: string;
}>({
    type: 'CREDIT',
    creditId: '',
    billPayerId: '',
    credited: 0,
    createdAt: moment(),
    note: '',
    behaviors: new BehaviorsCollection([]),
    accountId: undefined,
}) {}

const fromFormData = (formData: any) => {
    return new Credit({
        credited: parseDecimalToFloat(formData.credited)!,
        note: formData.note,
        accountId: formData.accountId,
    });
};

const fromAPI = (response: any, behaviorCollection?: BehaviorsCollection) => {
    return new Credit({
        billPayerId: response.billPayerId,
        creditId: response.creditId,
        credited: response.credited,
        createdAt: moment(response.createdAt),
        note: response.note,
        behaviors: behaviorCollection ? behaviorCollection : new BehaviorsCollection(response.behaviors || []),
        accountId: response.accountId,
    });
};

const toAPI = (credit: Credit) => {
    return {
        credited: credit.credited,
        note: credit.note,
        accountId: credit.accountId,
    };
};

export default {
    record: Credit,
    fromFormData,
    fromAPI,
    toAPI,
};
